import { chime } from "../lib/chime";
import { useSignalSound } from "../store/useSignalSound";

/**
 * Выключатель звука карточек сигналов.
 *
 * # Почему в шапке, а не на странице сигналов
 *
 * Звонит карточка, которая висит в макете и видна с любой страницы; выключатель,
 * спрятанный на своей вкладке, искали бы под звук. Соседи по шапке ровно те же
 * по смыслу — состояние рабочего места, а не рынка.
 *
 * # Почему включение проигрывает тон
 *
 * Две причины разом. Оператор слышит, ЧТО именно зазвучит, а браузер получает
 * свой обязательный жест: AudioContext, созданный до первого клика по странице,
 * спит, и без такого «пробного» тона первая карточка молчала бы даже при
 * включённом звуке (см. lib/chime.ts).
 */
export function SignalSoundToggle() {
  const on = useSignalSound((s) => s.on);
  const toggle = useSignalSound((s) => s.toggle);

  return (
    <button
      type="button"
      onClick={() => {
        if (!on) chime();
        toggle();
      }}
      className="text-xs"
      style={{ color: on ? "var(--color-fg)" : "var(--color-muted)" }}
      title={
        on
          ? "звук карточки сигнала включён — нажмите, чтобы выключить"
          : "звук карточки сигнала выключен; браузер включает звук только после клика по странице"
      }
      aria-pressed={on}
    >
      <span aria-hidden>{on ? "🔔" : "🔕"}</span>{" "}
      <span>{on ? "звук" : "без звука"}</span>
    </button>
  );
}
